function openClosedMI(MI) {
    if (innerWidth <= 500) return
    const DM = document.querySelector('[data-margin]')
    const interval = setInterval(() => {
        DM.setAttribute('style', `margin-top: ${MI.clientHeight}px`)
    }, 50)

    setTimeout(() => {
        clearInterval(interval)
    }, 500)
}